import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './hooks/useAuth';
import { Layout } from './components/Layout/Layout';
import ProtectedRoute from './components/ProtectedRoute';

// Pages
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import DashboardPage from './pages/DashboardPage';
import MyProfilePage from './pages/MyProfilePage';
import UsersManagementPage from './pages/UsersManagementPage';
import CompanyManagementPage from './pages/CompanyManagementPage';
import ActaManagementPage from './pages/ActaManagementPage';
import MetricasPage from './pages/MetricasPage';

function App() {
    return (
        <Router>
            <AuthProvider>
                <Routes>
                {/* Public Routes */}
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="/register" element={<RegisterPage />} />
                    
                    {/* Protected Routes with Layout */}
                    <Route path="/" element={
                        <ProtectedRoute>
                            <Layout>
                                <DashboardPage />
                            </Layout>
                        </ProtectedRoute>
                    } />
                
                    <Route path="/dashboard" element={
                        <ProtectedRoute>
                            <Layout>
                                <DashboardPage />
                            </Layout>
                        </ProtectedRoute>
                    } />
                
                    <Route path="/my-profile" element={
                        <ProtectedRoute>
                            <Layout>
                                <MyProfilePage />
                            </Layout>
                        </ProtectedRoute>
                    } />
                
                    <Route path="/users" element={
                        <ProtectedRoute requireSupervisor={true}>
                            <Layout>
                                <UsersManagementPage />
                            </Layout>
                        </ProtectedRoute>
                    } />

                    <Route path="/companies" element={
                        <ProtectedRoute requireSupervisor={true}>
                            <Layout>
                                <CompanyManagementPage />
                            </Layout>
                        </ProtectedRoute>
                    } />

                    {/* ✅ CORRECCIÓN: Actas accesible para todos los autenticados */}
                    <Route path="/actas" element={
                        <ProtectedRoute>
                            <Layout>
                                <ActaManagementPage />
                            </Layout>
                        </ProtectedRoute>
                    } />

                    {/* ✅ CORRECCIÓN: Métricas solo para supervisores/gerentes */}
                    <Route path="/metricas" element={
                        <ProtectedRoute requireManager={true}>
                            <Layout>
                                <MetricasPage />
                            </Layout>
                        </ProtectedRoute>
                    } />

                    {/* Redirect root to dashboard for authenticated users */}
                    <Route path="*" element={<Navigate to="/dashboard" replace />} />
                </Routes>
            </AuthProvider>
        </Router>
    );
}

export default App;